import { router } from "@inertiajs/react"
import type { Page } from "@inertiajs/core"
import posthog from "posthog-js"
import { useEffect, useRef } from "react"

import { identifyUser, resetUser, trackPageView } from "@/lib/analytics"
import type { SharedProps } from "@/types"

export function usePostHogIdentify() {
  const prevUserIdRef = useRef<number | null>(null)
  const wasImpersonatingRef = useRef(false)

  useEffect(() => {
    function identify(page?: Page) {
      const props = (page?.props ??
        (router as unknown as { page?: Page }).page?.props ??
        {}) as SharedProps
      const { currentUser, currentAccount, impersonating } = props

      if (impersonating) {
        if (!wasImpersonatingRef.current) {
          posthog.opt_out_capturing()
          wasImpersonatingRef.current = true
        }
        return
      }

      if (wasImpersonatingRef.current) {
        posthog.opt_in_capturing()
        wasImpersonatingRef.current = false
      }

      if (currentUser && currentAccount) {
        if (prevUserIdRef.current !== currentUser.id) {
          identifyUser(currentUser, currentAccount)
          prevUserIdRef.current = currentUser.id
        }
      } else if (prevUserIdRef.current !== null) {
        resetUser()
        prevUserIdRef.current = null
      }
    }

    identify()
    trackPageView(window.location.href)
    return router.on("navigate", (event) => {
      identify(event.detail.page)
      trackPageView(event.detail.page.url)
    })
  }, [])
}
